import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'favories',
})
export class FavoriesPipe implements PipeTransform {
  transform(id: any, args?: any, args2?: any, isLive?: boolean): any {
    if (isLive) {
      const filteredMatchDataLive = JSON.parse(localStorage.getItem('_F'));

      if (filteredMatchDataLive) {
        const isMatch = filteredMatchDataLive.find(x => x == id);

        return Boolean(isMatch);
      }
    } else {
      const filteredMatchData = JSON.parse(localStorage.getItem('_FavoritesPreMatch'));

      if (filteredMatchData) {
        const isMatch = filteredMatchData.find(x => x.BetradarMatchId == id);

        return Boolean(isMatch);
      }
    }
  }
}
